// @ts-nocheck
/* eslint-disable */
import { node, icon } from "~/util/dom";
import { _ } from "~/i18n";
import { MONTHS_ABBREVIATIONS } from "./constants";

const ALL_SEASONS = "all";

/**
 * cele obdobi - nic nezobrazujeme,
 * rok - cely, vcetne prazdnych mesicu
 */
export default class FilterSeasonChart {
	constructor(list, opts = {}) {
		this._list = list;
		this._opts = Object.assign({
			minGraphHeight: 5 // [%] misto nuly min pocet procent pro zobrazeni prazdnych mesicu
		}, opts);

		this._dom = {
			seasonPicker: node("div", { className: "season-picker" }),
			selector: node("div", { className: "selector" }),
			minCircle: node("span", { className: "circle min" }),
			maxCircle: node("span", { className: "circle max" }),
			items: node("div", { className: "items" }),
			item: []
		}

		this._data = null;

		this._activeId = 0;
		this._prevItemsHeight = [];
		this._selectorInterval = [];
		this._seasonPickerBBox = null;
		this._separators = [];
		this._moveElement = null;
		this._from = 0;
		this._to = 0;
		this._tmp = null;
		this._season = ALL_SEASONS;

		this._create();
	}

	destroy() {
		this._dom.selector.removeEventListener("pointerdown", this);
		this._dom.yearSelector.removeEventListener("pointerdown", this);
		window.removeEventListener("resize", this, false);
		this._dom.items.removeEventListener("click", this, false);
	}

	get container() {
		return this._dom.seasonPicker;
	}

	get data() {
		return this._data;
	}

	set data(data) {
		this._data = data;
	}

	set show(id) {
		let data = this._getChartData(id);

		this._season = id;
		this._list.season = id;

		if (!Object.keys(data).length) {
			data = this._buildEmptyItem(id);
		}

		this._createSeasonPicker(data);
	}

	get fromToSetted() {
		if (!this._data) { return false; }
		let seasonData = this._getChartData(this._season);
		let items = Object.keys(seasonData).length ? seasonData.items : this._buildEmptyItem().items;
		return this._from != 0 || (this._to != items.length && this._to != 0);
	}

	filterItems() {
		let dates = this._getFilerDate();

		this._list.changeFilter();
		this._list.getItems(dates.from, dates.to);
	}

	redraw() {
		let data = this._getChartData(this._season);
		let items = Object.keys(data).length ? data.items : this._buildEmptyItem().items;
		let max = 0;
		let actualItemsHeight = [];
		this._separators = [];
		this._dom.item = [];

		this._dom.items.innerHTML = "";

		for (let i = 0; i <= items.length; i++) {
			let itemData = this._createSeasonItem(true);
			this._dom.items.appendChild(itemData.item);
			this._separators.push(itemData);
			if (i > 0 && i < items.length) {
				itemData = this._createSeasonItem(true);
				this._dom.items.appendChild(itemData.item);
				this._separators.push(itemData);
			}

			if (i >= 0 && i < items.length) {
				itemData = this._createSeasonItem(false, items[i].text, items[i].id);

				this._dom.items.appendChild(itemData.item);
				this._dom.item[i] = itemData;

				if (items.length == this._prevItemsHeight.length) {
					this._dom.item[i].count.style.maxHeight = this._prevItemsHeight[i] + "%";
				}
				else {
					this._dom.item[i].count.style.maxHeight = this._opts.minGraphHeight + "%";
				}

				max = Math.max(max, items[i].value);
			}
		}

		requestAnimationFrame(()=> {
			this._setSelectorInterval();
			this._updateSelected();
			this._setInterval();
		});

		setTimeout(() => {
			for (let i = 0; i < items.length; i++) {
				let value = items[i].value;
				let height = max == 0 ? 0 : Math.round(100 * value / max);

				this._dom.item[i].count.style.maxHeight = Math.max(height, this._opts.minGraphHeight) + "%";
				actualItemsHeight.push(Math.max(height, this._opts.minGraphHeight));
			}

			this._prevItemsHeight = actualItemsHeight;
		}, 100);
	}

	clear() {
		this._data = null;
		this._from = 0;
		this._to = 0;
		this._season = ALL_SEASONS;
	}

	handleEvent(e) {
		switch(e.type) {
			case "pointerdown":
				e.stopPropagation();
				e.preventDefault();

				this._tmp = {
					from: this._from,
					to: this._to
				};

				if (this._dom.minCircle.contains(e.target) || this._dom.maxCircle.contains(e.target)) {
					this._dom.selector.addEventListener("pointermove", this);
					document.addEventListener("pointerup", this);
					this._moveElement = this._dom.minCircle.contains(e.target) ? this._dom.minCircle : this._dom.maxCircle;
				}
				else {
					this._moveElement = this._seasonPickerBBox.width / (e.clientX - this._seasonPickerBBox.left) >= 2 ? this._dom.minCircle : this._dom.maxCircle
					this._findInterval(e);
					this._updateSelected();

					if (this._tmp.from != this._from || this._tmp.to != this._to) {
						this.filterItems();
					}
				}
				break;

			case "pointermove":
				e.stopPropagation();
				e.preventDefault();

				this._findInterval(e);
				this._updateSelected();
				break;

			case "pointerup":
				e.stopPropagation();
				e.preventDefault();

				this._dom.selector.removeEventListener("pointermove", this);
				document.removeEventListener("pointerup", this);
				this._moveElement = null;

				if (this._tmp.from != this._from || this._tmp.to != this._to) {
					this.filterItems();

					Mapy.getComponent("logger").log("casovy_filtr_interakce", {
						setting: "osa-usek"
					});
				}

				this._tmp = null;
				break;

			case "resize":
				if (this._separators.length && this._dom.seasonPicker.offsetWidth > 0) {
					requestAnimationFrame(()=> {
						this._setSelectorInterval();
					});
				}
				break;

			case "click":
				if (e.target.getAttribute("data-item-season")) {
					this.show = e.target.getAttribute("data-item-season");
					this.filterItems();

					Mapy.getComponent("logger").log("casovy_filtr_interakce", {
						setting: "osa-obdobi"
					});
				} else if (e.target.getAttribute("data-item-month")) {
					let month = parseInt(e.target.getAttribute("data-item-month"), 10) - 1;
					let minMonth = 0;
					let maxMonth = 12;

					if (this._from == minMonth) {
						this._from = month;
					}
					else if (this._to == maxMonth) {
						this._to = month;
					}
					else {
						// blizsi
						let minDist = Math.abs(month - this._from);
						let maxDist = Math.abs(this._to - month);

						if (minDist < maxDist) {
							this._from = month;
						}
						else {
							this._to = month;
						}
					}

					this._updateSelected();
					this._setInterval();
					this.filterItems();

					Mapy.getComponent("logger").log("casovy_filtr_interakce", {
						setting: "osa-mesic"
					});
				}
				break;
		}
	}

	_create() {
		this._dom.seasonPicker.appendChild(this._dom.items);
		this._dom.minCircle.setAttribute("touch-action", "none");
		this._dom.minCircle.appendChild(icon("mover"));
		this._dom.maxCircle.appendChild(icon("mover"));
		this._dom.maxCircle.setAttribute("touch-action", "none");
		this._dom.selector.appendChild(this._dom.minCircle);
		this._dom.selector.appendChild(this._dom.maxCircle);

		this._dom.selector.addEventListener("pointerdown", this);
		window.addEventListener("resize", this, false);
		this._dom.items.addEventListener("click", this, false);

		this._dom.seasonPicker.appendChild(this._dom.selector);
	}

	_getChartData(id) {
		let data = {};

		for (let i = 0; i < this._data.length; i++) {
			if (this._data[i].id == id.toString()) {
				data = this._data[i];
				this._activeId = i;
				break;
			}
		}

		return data;
	}

	_createSeasonPicker() {
		let seasonData = this._getChartData(this._season);
		let items = Object.keys(seasonData).length ? seasonData.items : this._buildEmptyItem().items;
		this._from = 0;
		this._to = items.length;

		this.redraw();
	}


	_createSeasonItem(isSeparator, cpt, id) {
		let item = node("span", { className: "item" });
		let top = node("span", { className: "top" });
		let line = node("span", { className: "line" });
		let caption = node("span", { className: "caption", innerHTML: cpt || "" });
		let count = null;

		if (isSeparator) {
			item.classList.add("separator");
		}
		else {
			count = node("span", { className: "count" });
			top.appendChild(count);

			let attr = this._season == ALL_SEASONS ? "data-item-season" : "data-item-month";

			count.setAttribute(attr, id);
			caption.setAttribute(attr, id);
		}

		item.appendChild(top);
		item.appendChild(line);
		item.appendChild(caption);

		return {
			item,
			top,
			count
		};
	}

	_updateSelected() {
		let separators = this._separators;

		for (let i = 0; i < this._dom.item.length; i++) {
			let action = i >= this._from && i < this._to ? "add" : "remove";
			separators[i*2].item.classList[action]("active");
			separators[i*2+1].item.classList[action]("active");
			this._dom.item[i].item.classList[action]("active");
			this._dom.item[i].item.classList.remove("border-left");
			this._dom.item[i].item.classList.remove("border-right");
			this._dom.item[i].item.classList.remove("only-two");
		}

		const fromInd = this._from;
		const toInd = this._to - 1;
		const size = this._to - fromInd;
		this._dom.item[this._from]?.item.classList.add("border-left");
		this._dom.item[toInd]?.item.classList.add("border-right");

		if (size === 2) {
			this._dom.item[fromInd]?.item.classList.add("only-two");
			this._dom.item[toInd]?.item.classList.add("only-two");
		}
	}

	_setSelectorInterval() {
		let separators = this._separators;
		let width = this._dom.seasonPicker.offsetWidth;

		this._seasonPickerBBox = this._dom.seasonPicker.getBoundingClientRect();
		this._selectorInterval = [];

		this._selectorInterval.push({ min: 0, max: separators[0].item.offsetWidth, pos: 0});

		if (separators.length > 2) {
			for (var i = 1; i < this._dom.item.length; i++) {
				let position = separators[i*2].item.offsetLeft;
				this._selectorInterval.push({ min: position-separators[i*2].item.offsetWidth, max: position+separators[i*2].item.offsetWidth, pos: position });
			}
		}

		this._dom.selector.style.width = width + "px";

		this._selectorInterval.push({ min: width-separators[separators.length-1].item.offsetWidth, max: width, pos: width });
	}

	_findInterval(e) {
		let position = e.clientX - this._seasonPickerBBox.left;

		for (var i = 0; i < this._selectorInterval.length; i++) {
			let interval = this._selectorInterval[i];

			if (position > interval.min && position < interval.max) {
				if ((i == 0 || this._from >= i) && this._moveElement == this._dom.maxCircle) { break; }
				if ((i == this._selectorInterval.length-1 || this._to <= i) && this._moveElement == this._dom.minCircle) { break; }
				this._moveElement.style.left = interval.pos + "px";

				if (this._moveElement == this._dom.minCircle) {
					this._from = i;
				}
				else {
					this._to = i;
				}
			}
		}
	}

	_setInterval() {
		if (this._setSelectorInterval.length === 0) {
			return;
		}

		const len = this._setSelectorInterval.length - 1;
		const fromInd = Math.max(0, Math.min(this._from, len));
		const toInd = Math.max(0, Math.min(this._to, len));

		this._dom.minCircle.style.left = this._selectorInterval[fromInd].pos + "px";
		this._dom.maxCircle.style.left = this._selectorInterval[toInd].pos + "px";
	}

	_getFilerDate() {
		let from = null;
		let to = null;
		let data = this._data[this._activeId];

		if (!data) {
			data = this._buildEmptyItem();
		}

		if (data) {
			from = data.items[this._from] ? data.items[this._from].from : null;
			to = data.items[this._to-1] ? data.items[this._to-1].to : null;
		}

		return { from, to };
	}

	_buildEmptyItem(id = this._activeId) {
		const data = {
			items: [],
			text: id,
			id: id.toString()
		};

		MONTHS_ABBREVIATIONS.forEach((text, k) => {
			const m = k + 1;
			data.items.push({
				text: _("calendar.shortMonths." + text),
				id: m.toString(),
				value: 0,
				from: (new Date(parseInt(id), m-1, 1, 0, 0, 0)).getTime(),
				to: (new Date(parseInt(id), m-1, (new Date(parseInt(id), m, 0).getDate()), 23, 59, 59)).getTime()
			})
		});

		return data;
	}
}
